import React from 'react';

const ChevronDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_614_17775"
        style={{
          maskType: 'alpha'
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_614_17775)">
        <path
          d="M11.9934 14.9367C11.8602 14.9367 11.7354 14.9158 11.6188 14.8738C11.5023 14.8326 11.3941 14.7621 11.2942 14.6623L6.6744 10.0468C6.49127 9.86384 6.40404 9.63498 6.4127 9.36021C6.42069 9.08611 6.51624 8.85758 6.69937 8.67463C6.8825 8.49167 7.11557 8.40019 7.39858 8.40019C7.6816 8.40019 7.91467 8.49167 8.09779 8.67463L11.9934 12.5666L15.914 8.64968C16.0971 8.46672 16.3262 8.37924 16.6012 8.38722C16.8756 8.39587 17.1043 8.49167 17.2874 8.67463C17.4705 8.85758 17.5621 9.09044 17.5621 9.37319C17.5621 9.65594 17.4705 9.88879 17.2874 10.0717L12.6926 14.6623C12.5927 14.7621 12.4845 14.8326 12.368 14.8738C12.2514 14.9158 12.1266 14.9367 11.9934 14.9367Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};

export default ChevronDown;
